<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <CDataTable
                :table-filter="{label:''}"
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                :items="history"
                :fields="fields"
                :items-per-page="small ? 50 : 20"
                :dark="dark"
                pagination
                :loading="loading"
            >
              <template #index="{item,index}">
                <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
              </template>


              <template #startDate="{item,index}">
                <td class="text-right"  @click="toggleDetails(item, index)"> {{ item.startDate }}</td>
              </template>


              <template #endDate="{item,index}">
                <td class="text-right"  @click="toggleDetails(item, index)"> {{ item.endDate }}</td>
              </template>


              <template ##="{item}">
                <td style="width: 140px">
                  <CRow>
                    <CCol class="text-right">
                      <CButton class="mr-1" v-c-tooltip.hover.click="'Remove'" size="sm" color="danger" shape="pill" variant="outline" @click="onRemove(item)"  >
                        <CIcon name="cil-trash"/>
                      </CButton>

                      <CButton class="mr-1" v-c-tooltip.hover.click="'Detail'" size="sm" color="info" shape="pill" variant="outline" @click="onUpdate(item)"  >
                        <CIcon name="cil-description"/>
                      </CButton>


                    </CCol>
                  </CRow>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>

</template>
<script>
  import {mapGetters} from 'vuex'
  import moment from "moment";
  export default {
    name: 'History',
    props: {
      icon: {
        type: String,
        default: 'cil-settings',
      },
      caption: {
        type: String,
        default: 'Historys'
      },

      item:{
        type: Array,
        default() {
          return []
        }
      },

      fields: {
        type: Array,
        default() {
          return [
            {key:"index", label: "ลำดับ",  _style: 'width:50px; text-align: center'},
            {key:"startDate", label:"เริ่มต้น",  _style: 'width:180px; text-align: center'},
            {key:"endDate", label:"สิ้นสุด",  _style: 'width:180px; text-align: center'},
            // {key:"description", label:"รายละเอียด",},
            {key:"#", label: "#", _style: 'width:100px; text-align: center'}
          ]
        }
      },
      type: {
        type: String,
        default: 'cil-user'
      },
      hover: Boolean,
      striped: Boolean,
      bordered: Boolean,
      small: Boolean,
      fixed: Boolean,
      dark: Boolean,
      loading:{
        type: Boolean,
        default() {
          return false
        }
      },

    },
    data () {
      return {
        history : [],
      }
    },

    mounted() {

    },

    created() {
      this.onInit();
    },

    beforeDestroy() {

    },

    methods: {
      onInit(){
        var data = {};
        this.$store.dispatch("account/config",data);
      },

      toggleDetails (item) {
        item._toggled = !item._toggled
        this.collapseDuration = 300
        this.$nextTick(() => { this.collapseDuration = 0})
      },

      onUpdate(item) {
        this.$emit('update', item);
      },

      onRemove(item) {
        this.$emit('remove', item);
      },

      onSetHistory(){
        try {
          this.history = this.item.map(objs => {
            return {
              value:objs,
              startDate: new moment(objs.startDate).format('YYYY-MM-DD HH:mm:ss'),
              endDate: new moment(objs.endDate).format('YYYY-MM-DD HH:mm:ss'),
              description: objs.description.find(obj => obj.key === this.lang)?.value || ''
            };
          });
        }catch (e) {

        }

        console.log(this.history);

      }

    },

    computed:{
      ...mapGetters({
        lang:'setting/lang',
      })
    },

    watch: {
      lang:function (value) {
        this.onSetHistory();
      },

      item:function(value){
        this.onSetHistory();
      }

    }
  }

</script>
